import { axios } from '../../../lib';

export const getAllRules = ({
  id = null,
  searchTerm=null,
  partnerCifs = null,
  worldClassPartnerName = null,
  pointOfWorks = null,
  categories = null,
  pageNumber = null,
  size = null,
  orderByList = null,
}) => {
  const payload = {
    ...(id && { id }),
    ...(partnerCifs && { partnerCifs }),
    ...(worldClassPartnerName && { worldClassPartnerName }),
    ...(pointOfWorks && {pointOfWorks}),
    ...(categories && { categories}),
    ...(searchTerm && { searchTerm}),
    pagination: {
      ...(pageNumber == null || size == null
        ? { pageNumber: null, size: null }
        : { pageNumber, size }),
      ...(orderByList && { orderByList }),
    },
  };

  return axios.post('/nomenclatures/rules/paginate', payload);
};
